import styled from "@emotion/styled"
import { PButtonPure } from "@porsche-design-system/components-react"
import { colorContrastLow, spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import type { StandardEquipmentItem } from "@slfinrtl/ui-bff-routes"
import { SpecialEquipmentItem } from "../special/SpecialEquipmentItem"

interface RichEquipmentItemProps {
	item: StandardEquipmentItem
	onClick?: (item: StandardEquipmentItem) => void
}

export const RichEquipmentItem = ({ item, onClick }: RichEquipmentItemProps) => (
	<Wrapper>
		<StyledButtonPure
			type="button"
			alignLabel="start"
			icon="information"
			stretch
			dangerouslySetInnerHTML={{ __html: item.overwrittenBy ? `<s>${item.name}</s>` : item.name }}
			onClick={() => onClick?.(item)}
		/>
		{item.overwrittenBy && <SpecialEquipmentItem item={item.overwrittenBy} onClick={onClick} />}
	</Wrapper>
)

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: ${spacingStaticSm} 0;
	border-bottom: 1px solid ${colorContrastLow};
`

const StyledButtonPure = styled(PButtonPure)`
	z-index: 1;
`
